import { render, staticRenderFns } from "./PrinterPrice.vue?vue&type=template&id=78dcb838&scoped=true&"
import script from "./PrinterPrice.vue?vue&type=script&lang=js&"
export * from "./PrinterPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dcb838",
  null
  
)

export default component.exports